<app-main-layout [mainTemplateRef]="main" [requireLogin]="false">
  <ng-template #main>
    <main>
      @if (show) {
        <article>
          <header><mat-icon id="pageNotAllowedIcon">warning</mat-icon></header>
          <section>
            <h1 id="pageNotAllowedTitle" class="mat-h1">{{ 'uix.403.title' | translate }}</h1>
            <p id="pageNotAllowedMessage">{{ 'uix.403.message' | translate }}</p>
          </section>
        </article>
      }
    </main>
  </ng-template>
</app-main-layout>
